<template>
  <div class="spread-wrap">
    <el-form :model="form.data" :inline="true">
      <el-form-item :label="'任务' | translateTo(i18nPath)">
        <el-select v-model="form.data.task" :placeholder="'请选择任务' | translateTo(i18nPath)">
          <el-option
            v-for="(item, index) in form.opts.tasks"
            :key="`${item.value}-${index}`"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="form.data.daterange"
          type="daterange"
          value-format="yyyy-MM-dd"
          :range-separator="'至' | translateTo(i18nPath)"
          :start-placeholder="'开始日期' | translateTo(i18nPath)"
          :end-placeholder="'结束日期' | translateTo(i18nPath)"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="search">{{ '查询' | translateTo(i18nPath) }}</el-button>
      </el-form-item>
    </el-form>
    <MTable
      :tableData="data"
      :loading="loading"
      :i18nPath="i18nPath"
      :pagiOption="pagiOption"
      :oprateMenu="oprateMenu"
      :tableColumn="tableColumn"
      v-on:search="search"
    />
    <el-dialog
      v-if="modelVisible"
      :title="'预测分析模型' | translateTo(i18nPath)"
      :visible="true"
      :append-to-body="true"
      width="70%"
      top="5vh"
      :before-close="modelHandler"
      custom-class="map-dialog"
    >
      <PuffMap :task-id="currTaskId" />
    </el-dialog>
  </div>
</template>

<script>
import MTable from '@/components/mTable/m-table.vue';

import PuffMap from './components/puff-map.vue';

import { getTaskAlarmList, getTaskNameList, getTaskSmokePuffDetail } from '@/api/dataAnalysis';

export default {
  components: {
    PuffMap,
    MTable
  },
  data() {
    return {
      i18nPath: 'dataAnalysis',
      modelVisible: false,
      loading: false,
      currTaskId: '',
      form: {
        opts: {
          tasks: []
        },
        data: {
          daterange: [],
          task: ''
        }
      },
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
      tableColumn: [
        { label: '任务名称', prop: 'taskName' },
        { label: '报警内容', prop: 'alarmContent' },
        { label: '报警时间', prop: 'alarmDate' }
      ],
      oprateMenu: {
        label: '操作',
        width: 360,
        list: [
          {
            text: '详情',
            access: () => true,
            event: (_, data) => {
              // 待办 扩散分析弹窗
              this.currTaskId = data.id;
              this.modelVisible = true;
              getTaskSmokePuffDetail(data.id);
            }
          }
        ]
      },
      data: null
    };
  },
  methods: {
    init() {
      this.getTaskNameList();
      this.search();
    },
    modelHandler() {
      this.modelVisible = false;
    },
    search() {
      const { offset, limit } = this.pagiOption;
      const { daterange, task } = this.form.data;
      this.getData({
        offset,
        limit,
        taskId: task,
        alarmDateBegin: daterange[0],
        alarmDateEnd: daterange[1]
      });
    },
    getData(params) {
      if (this.loading) return;
      this.loading = true;
      getTaskAlarmList(params)
        .then(res => {
          if (!res.data) return;
          this.pagiOption.total = res.data.total;
          this.data = this.data || [];
          this.data.splice(0, Infinity, ...res.data.list);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTaskNameList() {
      getTaskNameList()
        .then(res => {
          if (!Array.isArray(res.data) || !res.data.length) return;
          this.form.opts.tasks.splice(0, Infinity, ...res.data);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  created() {
    this.init();
  }
};
</script>

<style lang="scss">
.spread-wrap {
  position: relative;
}
</style>
